export const focusControl =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring'
export const focusField =
  'focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring'
export const focusRow =
  'focus-visible:bg-muted focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-ring'
export const focusInset =
  'focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-ring'
export const focusNavigation =
  'focus-visible:bg-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring'
export const interactionTransition = 'transition-colors duration-150 ease-out'
